import axios from 'axios'
import Cookies from 'js-cookie'
import { showNotify, showDialog } from 'vant'
import { clearMajorCatalogSession, notifyGlobalMajorLoginOpen } from '@/common/js/majorCatalogSession'
window.parsedBaseUrl = window.location.protocol + '//jxzypt.hcvt.cn/'
window.baseURL = window.parsedBaseUrl + '/visitorApp' // http://www.hcvt.cn/visitorApp http://111.28.188.65:8080/visitorApp/
// window.baseURL = "http://192.168.12.158:8088/" // http://www.hcvt.cn/visitorApp http://111.28.188.65:8080/visitorApp/
const service = axios.create({
  baseURL: window.baseURL,
  timeout: 1200000, // request timeout
  headers: {
    'Content-Type': 'application/json',
  },
})

// 请求拦截
service.interceptors.request.use(
  config => {
    let access_token = Cookies.get('access_token')
    if (access_token !=undefined && access_token.length > 0){
        if (config.url.indexOf('?') > 0){
            config.url = config.url + '&access_token=' + access_token
        }else{
            config.url = config.url + '?access_token=' + access_token
        }
    }
    return config
  },
  error => {
      return Promise.reject(error)
  }
)

// 响应拦截
service.interceptors.response.use(
  async response => {
    let resultData = response.data;
    if (resultData.ds_code == -9999){
      showNotify('服务未启动！')
      return resultErrorData()
    } else if (resultData.resultCode == -9999 || resultData.resultCode == '-9999') {
      const msg =
        (resultData.resultMsg && String(resultData.resultMsg).trim()) ||
        'access_token已过期或失效！请重新登录'
      try {
        clearMajorCatalogSession()
      } catch (e) {
        /* ignore */
      }
      showNotify({ type: 'warning', message: msg })
      notifyGlobalMajorLoginOpen({ message: msg })
      return resultErrorData()
    }else if (resultData.resultCode == '-9998'){
      showDialog({
          title:'温馨提示',
          message: resultData.resultMsg,
          theme:'round-button'
      }).then(() =>{});
    }else if (resultData.resultCode == '-1001'){
      showNotify(resultData.resultMsg);
    }else if (resultData.resultCode == '-1002'){
      showNotify(resultData.resultMsg);
    }else{
        return resultData
    }
  },
  error => {
      return Promise.reject(error)
  }
)

function resultErrorData(){
  return {
    'resultCode': '-1',
    'resultMsg': '请求异常！'
  }
}

export default service
